




































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";

// Enums/Data
import { getLocaleCountryCode } from "@/data/enums/i18n";

// Types
import { ILanguage } from "@/models/constants";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      languages: (state: IState) => state.brand.languages
    })
  }
})
export default class TermsTranslationsGrid extends Vue {
  // Map state

  public languages!: ILanguage[];

  // Props

  @Prop({ required: true })
  public languageIds!: ILanguage["id"];

  @Prop({ required: true })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public userCan!: any;

  // Computed

  public get orderedLangs() {
    return this.$_.orderBy(this.languages, ["language"], ["asc"]);
  }

  // Methods

  public hasLanguage(languageId: ILanguage["id"]) {
    return this.languageIds.includes(languageId);
  }

  public getLanguageLabel(language: ILanguage) {
    const hasLanguage = this.hasLanguage(language.id);

    if (hasLanguage)
      return this.userCan.update
        ? this.$t("_action.edit_translation")
        : this.$t("_action.view");

    return this.userCan.create ? this.$t("_action.add_translation") : "";
  }

  public getLocaleCountryCode(code: string) {
    return getLocaleCountryCode(code);
  }
}
